import axios from "axios";
import process from "process";
import { QueryClient } from "@tanstack/react-query";

// const frontUrl = "https://approvalbackend.vercel.app";
const frontUrl = import.meta.env.VITE_APPROVAL_BACKEND_URL;

const apiClient = axios.create({
	baseURL: frontUrl,
});

const apiClientPrivate = axios.create({
	baseURL: frontUrl,
	withCredentials: true,
});

const queryClient = new QueryClient();

export { apiClient, queryClient, apiClientPrivate };
